// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"BookItSettingsPage_formContainer__2OGHY","saveButton":"BookItSettingsPage_saveButton__1IoWy"};